module.exports = __webpack_public_path__ + "assets/img/apple.1fcf04c4.png";